












































































import Vue, { PropType } from 'vue';
import ComponentSelectCharacter from './SelectCharacter.vue';
import ComponentSelectArtifact from './SelectArtifact.vue';

export interface Enemy {
  name: string;
  artifact: string;
  hp: number;
  cr: number;
  outspeed: boolean;
  counter: boolean;
  immunity: boolean;
  lifesteal: boolean;
  injury: boolean;
  infos: string;
}

export default Vue.extend({
  components: {
    SelectCharacter: ComponentSelectCharacter,
    SelectArtifact: ComponentSelectArtifact,
  },
  props: {
    uid: String,
    cid: String,
    enemy: Object as PropType<Enemy>,
    labelHero: String,
    labelArtifact: String,
  },
  data() {
    return {
      defaultArtifactRole: '',
    };
  },
});
